import { ActionIcon, Tooltip } from '@mantine/core';
import { modals } from '@mantine/modals';
import { createConfirmDeleteLogModal } from 'components/Modal/ConfirmModals';
import { useCustomMutation } from 'hooks/api/useCustomMutation';
import { useTranslation } from 'react-i18next';
import { BsTrash } from 'react-icons/bs';
import { deleteLogRecord } from 'services/logs';
import { queryKeys } from 'utils/query';

interface Props {
  logId: string;
}

export const DeleteLogActionIcon = ({ logId }: Props) => {
  const { t } = useTranslation();
  const { mutate: deleteLogMutation, isPending: isPendingDeleteLog } = useCustomMutation({
    fn: deleteLogRecord,
    onSuccess: {
      message: t('success_data_deleted', { value: t('log_label') }),
      invalidateQueryKeys: [[queryKeys.patientMedicalEvents], [queryKeys.logs]],
    },
  });

  const handleDeleteLog = () => {
    deleteLogMutation({ logId });
  };

  const openDeleteModal = () => {
    modals.openConfirmModal(createConfirmDeleteLogModal(handleDeleteLog));
  };
  return (
    <>
      <Tooltip label={t('delete_label')}>
        <ActionIcon onClick={openDeleteModal} variant={'outline'} loading={isPendingDeleteLog} size={'sm'}>
          <BsTrash color={'var(--mantine-color-red-5)'} size={16} />
        </ActionIcon>
      </Tooltip>
    </>
  );
};
